export enum AttackStatus {
  PROBED = 'PROBED',
  PROBED_PERIMETER = 'PROBED_PERIMETER',
  BLOCKED = 'BLOCKED',
  BLOCKED_PERIMETER = 'BLOCKED_PERIMETER',
  EXPLOITED = 'EXPLOITED',
  SUSPICIOUS = 'SUSPICIOUS'
}

export const attackStatusi18nConfig: Record<AttackStatus, string> = {
  [AttackStatus.BLOCKED]: 'title_attackStatusBlocked',
  [AttackStatus.BLOCKED_PERIMETER]: 'title_attackStatusBlockedPerimeter',
  [AttackStatus.PROBED]: 'title_attackStatusProbed',
  [AttackStatus.PROBED_PERIMETER]: 'title_attackStatusProbedPerimeter',
  [AttackStatus.EXPLOITED]: 'title_attackStatusExploited',
  [AttackStatus.SUSPICIOUS]: 'title_attackStatusSuspicious'
}

export function isValidStatus(status: string) {
  return Object.keys(AttackStatus).find((v) => v === status)
}

export enum AttackType {
  MANUAL = 'MANUAL',
  AUTOMATED = 'AUTOMATED'
}
